import React from 'react';
import { IProps as IBlockProps } from '@/blocks/SubscriptionBlock/SubscriptionBlock.interface';
import { SubscriptionBlock } from './SubscriptionBlock.component';

import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';

export interface IBlockInputProps {
  title?: string;
  form: string;
  background: ThemeColors;
  // Allow passthrough of other props for BlockWrapper
  [key: string]: any;
}

const mapInputToProps = (input: IBlockInputProps): IBlockProps => {
  const {
    title,
    form,
    background,
    ...rest // Capture all other props for BlockWrapper
  } = input;

  return {
    title,
    form,
    backgroundColor: background || 'brand-3', // Default to white if not provided
    ...rest, // Spread them onto the component's props
  };
};

/**
 * Translation component wrapper for OptimizelyFormBlock.
 * This component facilitates mapping data from an external source (like a CMS)
 * to the OptimizelyFormBlock's props, including BlockWrapper settings.
 */
const BlockTranslation: React.FC<IBlockInputProps> = (inputProps) => {
  return (
    <TranslationComponent
      inputProps={inputProps}
      TargetComponent={SubscriptionBlock}
      mapProps={mapInputToProps}
    />
  );
};

export default BlockTranslation;
